import { AuthorizationGetterTypes } from './types';

export const getters = {
    [AuthorizationGetterTypes.GetGroup](state) {
        return state.group
    },
    [AuthorizationGetterTypes.GetId](state) {
        return state.id
    },
    [AuthorizationGetterTypes.GetRole](state) {
        return state.role
    },
}